import { useEffect } from "react";
import { AgentPanel } from "./components/ObserverUI/AgentPanel";
import { EventBanner } from "./components/ObserverUI/EventBanner";
import { EventFeed } from "./components/ObserverUI/EventFeed";
import { StatsBar } from "./components/ObserverUI/StatsBar";
import { SpaceCanvas } from "./components/SpaceCanvas/SpaceCanvas";
import { useAgentSSE } from "./hooks/useAgentSSE";
import { loadStarSystems } from "./services/celestialData";
import { useObserverStore } from "./stores/observerStore";

export function App(): React.JSX.Element {
	const setSystems = useObserverStore((s) => s.setSystems);

	// Load star systems on mount
	useEffect(() => {
		const systems = loadStarSystems();
		setSystems(systems);
	}, [setSystems]);

	// Connect to SSE for real-time agent events
	useAgentSSE();

	return (
		<>
			<SpaceCanvas />
			<StatsBar />
			<EventBanner />
			<EventFeed />
			<AgentPanel />
		</>
	);
}
